import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const HeaderGrid = styled(Grid)`
  border-bottom: 1px solid;
`;

export const CheckboxGrid = styled(Grid)`
  display: flex;
`;

export const CheckboxValueGrid = styled(Grid)`
  align-content: center;
`;

export const FormTextField = styled(TextField)`
  width: -webkit-fill-available;
`;
